<div class="modal-header">
    <div class="modal-title">Feedback/Suggestions</div>

    <button id="add-interim-popup-close" type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <div class="row mb-3">
        <div class="col-md-12">
            <div class="font-size-18 font-weight-bold">Feedback about <span class="color--blue">{{pageName}}</span> page</div>
        </div>
    </div>

    <form #feedbackForm="ngForm" novalidate="novalidate" autocomplete="off">

        <div class="row quill__component">
            <div class="col-md-12">
                <quill-editor name="editor" class="custom__scroll" [placeholder]="feedbackText ? '' : 'Type your feedback here...'" [(ngModel)]="feedbackText"
                    [modules]="quillModules" required></quill-editor>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-12">
                <div class="font-size-18 font-weight-bold">Here are a few examples of feedback that were submitted which we’ve already implemented:</div>
            </div>
        </div>

        <div class="row my-2">
            <div class="col-md-12">
                <div class="font-size-14 py-1">
                    <svg-icon name="blue-square-bullet" svgClass="mr-2"></svg-icon>
                    I’d like the ability to enter figures into the Income Statement screen in thousands
                </div>
                <div class="font-size-14 py-1">
                    <svg-icon name="blue-square-bullet" svgClass="mr-2"></svg-icon>
                    I’d like for you to suggest with weightings for me on the Weightings screen
                </div>
                <div class="font-size-14 py-1">
                    <svg-icon name="blue-square-bullet" svgClass="mr-2"></svg-icon>
                    I’d like to add notes on each screen, with the option of including them in the final report
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <label class="checkbox m-0">
                    <input class="checkbox__input" type='checkbox' id="isContact" [value]="true"
                    [checked]="feedbackContact" (change)="feedbackContact = !feedbackContact;" />
                    <div class="checkbox__data px-0 pb-0">
                      <div class="checkbox__indicator"></div>
                      <p class="checkbox__text font-size-14__imp font-weight-bold">
                        It’s okay to contact me about my feedback.
                      </p>
                    </div>
                </label>
            </div>
        </div>

    </form>
</div>

<div class="modal-footer">
    <button type="button" class="button secondary__button large__button position-static"
        (click)="cancel()">Cancel</button>
    <button type="button" class="button primary__button large__button position-static"
        [disabled]="!feedbackForm.valid" (click)="submit()">Submit Feedback</button>
</div>
